import React from "react";

export default function VaultSecureLogo({ className = "h-6 w-6", color = "currentColor" }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color: color }}
    >
      {/* Protective shield outline embracing the V */}
      <path
        d="M12 2L4 6V12C4 16.5 7.5 20 12 22C16.5 20 20 16.5 20 12V6L12 2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
        fill="none"
        opacity="0.3"
      />

      {/* Upside down triangle inside shield */}
      <path
        d="M8 8L16 8L12 16Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
        fill="currentColor"
        opacity="0.8"
      />

      {/* Lock element at bottom */}
      <circle cx="12" cy="17" r="1.5" fill="currentColor" />
      <rect x="11.25" y="15.5" width="1.5" height="2.5" fill="currentColor" />
    </svg>
  );
}
